document.addEventListener('DOMContentLoaded', function () {
  var roomvo_button = document.getElementsByClassName('roomvo-stimr')[0];
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === "attributes") {
        var is_hidden = mutation.target.style.visibility == 'hidden';

        if (is_hidden) {
          mutation.target.closest('.roomvo-container').classList.add('hidden');
        } else {
          mutation.target.closest('.roomvo-container').classList.remove('hidden');
        }
      }
    });
  });
  
  observer.observe(roomvo_button, {
    attributes: true
  });
}, false);
